import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import TutorAbout from "./TutorAbout";
import InstitutionAbout from "./InstitutionAbout";
import PersonalInfoForm from "../forms/PersonalInfoForm";
import BioForm from "../forms/BioForm";
import SocialForm from "../forms/SocialForm";

const AboutSection = ({ setStatusModal }) => {
  const { user } = useAuth();



  if (user?.role === "institution") {
    return <InstitutionAbout user={user} setStatusModal={setStatusModal} />;
  }

  return <TutorAbout user={user} setStatusModal={setStatusModal} />;
};

export default AboutSection;
